<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import AuthSupportLinks from '@/components/views/manage-account/AuthSupportLinks.vue'
import SwiftyLottie from '@/components/dashboard/ui/SwiftyLottie.vue'
import swiftyLost from '@/assets/images/swifty-lost.json'

/**
 * Catch-all for unknown URLs. AuthLayout gives it the same branded shell as
 * login and maintenance, instead of the empty BlankLayout fallback.
 * Signed-in donors go back to the dashboard; everyone else goes to login.
 */
const store = useStore()

const isAuthenticated = computed(() => Boolean(store.state.auth.authenticated))

const ctaTo = computed(() =>
  isAuthenticated.value ? { name: 'Dashboard' } : { name: 'Login' }
)

const ctaLabelKey = computed(() =>
  isAuthenticated.value ? 'NotFound.DashboardCta' : 'NotFound.LoginCta'
)
</script>

<template>
  <div class="sa-auth-step sa-auth-status-page" data-testid="not-found-page">
    <header class="sa-auth-step__header">
      <SwiftyLottie
        class="sa-auth-status-page__lottie"
        :animation-data="swiftyLost"
      />
      <p class="sa-auth-step__eyebrow">
        {{ $t('NotFound.Eyebrow') }}
      </p>
      <h1 class="sa-auth-step__title">
        {{ $t('NotFound.Title') }}
      </h1>
      <p class="sa-auth-step__lead">
        {{ $t('NotFound.Lead') }}
      </p>
    </header>

    <div class="sa-auth-status-page__status">
      <router-link
        :to="ctaTo"
        class="sa-btn-primary sa-auth-form__submit"
      >
        {{ $t(ctaLabelKey) }}
      </router-link>
    </div>

    <AuthSupportLinks lead-key="NotFound.SupportLead" />
  </div>
</template>
